module.exports = __webpack_public_path__ + "static/media/education.6b8b7175.svg";